import React, { CSSProperties, forwardRef, ReactNode } from "react";

import classNames from "classnames";

import { InputField } from "studio-design-system";

import * as styles from "./InputFieldWrap.css";

interface Props extends React.HTMLProps<HTMLInputElement> {
  rightAction?: RightAction;
}

interface RightAction {
  enabled: boolean;
  text: string;
  callback: (val: any) => void;
}

export const InputFieldWrap = (props: Props) => {
  return (
    <div className={classNames(styles.inputWrap)}>
      <InputField {...props} className={styles.input} />
      {props.rightAction && (
        <div
          className={styles.inputRightAction}
          onClick={() => props.rightAction?.callback(props.value)}
        >
          {props.rightAction.text}
        </div>
      )}
    </div>
  );
};
